@if (showIconBtnVariant) {
  <ng-container *ngTemplateOutlet="favoriteIconIconBtnTemplate"></ng-container>
} @else {
  <div class="fav-btn" (click)="toggleFavoriteTrackHandler($event)">
    <div class="btv-icon-favorite" [ngClass]="{ 'btv-icon-favorite--active': isFavorite }"></div>
    @if (dropdownMode) {
      <p class="fav-btn__title">{{ lg.tracksBlock.addFavoriteDrop }}</p>
    }
  </div>
}

<ng-template #favoriteIconIconBtnTemplate>
  <bmcore-button [styleName]="getIconBtnVariant()" (clickHandler)="toggleFavoriteTrackHandler($event)">
    @if (isFavorite) {
      <bmcore-favourite-icon [width]="iconSize" [height]="iconSize" fillColor="#E7B73D"></bmcore-favourite-icon>
    }

    @if (!isFavorite) {
      <bmcore-favourite-outline-icon [width]="iconSize" [height]="iconSize"></bmcore-favourite-outline-icon>
    }
  </bmcore-button>
</ng-template>
